import { RouteConfig } from 'vue-router'

import {
	TaskSheetIndex,
  FormTaskSheet
} from '@/views'

const taskSheetRouter: Array<RouteConfig> = [
	{
    path: '/task-sheets',
    name: 'task-sheets',
    component: TaskSheetIndex,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Hojas de Tareo'
    }
  },
  {
    path: '/task-sheets/form/:id?',
    name: 'task-sheet-form',
    component: FormTaskSheet,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Crear/Editar Hojas de Tareo'
    }
  }
]

export default taskSheetRouter
